// extracted by mini-css-extract-plugin
module.exports = {"teaser":"Teaser_teaser__f8icb","video":"Teaser_video__sQ1HG","text":"Teaser_text__iujtl","card":"Teaser_card__5tj68"};